import { XCircle } from "lucide-react";

const ErrorToast = ({ text = "Error!", animation, animationDuration, onClick }) => (
  <div
    className={`alert alert-error ${animation} cursor-pointer relative overflow-hidden
      transition-all duration-200 ease-out
      hover:scale-[1.02] hover:shadow-lg hover:brightness-105
      active:scale-[0.98] active:shadow-md
      border-l-4 border-error backdrop-blur-sm`}
    style={{ animationDuration: `${animationDuration}ms` }}
    onClick={onClick}
  >
    <div className="flex items-center gap-3 relative z-10">
      <XCircle className="h-5 w-5 shrink-0" />
      <span className="font-medium">{text}</span>
    </div>
    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-full hover:translate-x-full transition-transform duration-700" />
  </div>
);

export default ErrorToast;
